import React from "react";

import MobileDialog from "@app/analytics/MeetingReport/components/MobileDialog";
import useExternalShareProviders from "@app/analytics/MeetingReport/MeetingReportHeader/ExternalShareMenu/useExternalShareProviders";

import { Column } from "@rui/Stack";

import type { ExternalShareMenuProps } from "./types";

type ExternalShareDialogProps = Omit<ExternalShareMenuProps, "variant">;

const ExternalShareDialog = (props: ExternalShareDialogProps) => {
  const { all: shareProviders } = useExternalShareProviders({
    variant: "dialog",
  });

  return (
    <MobileDialog id="external_share_select" title="Push to...">
      <Column spacing={1}>
        {shareProviders.map(({ Component, ...provider }) => (
          <Component
            key={provider.providerId}
            {...props}
            {...provider}
            variant="dialog"
          />
        ))}
      </Column>
    </MobileDialog>
  );
};

export default ExternalShareDialog;
